import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
import { create } from 'braintree-web/hosted-fields';
import AbstractPaymentMethodService from './AbstractPaymentMethodService';
import { ValidationManager, parseString, SubType, UserAddressCommandNames, PaymentMethodsCommandNames, ElementType, StatusTypes, SpecType, sendRioEvent } from '@chegg/commerce-utils';
import { clearFields as _clearFields, normalizeErrorMessage, handleCardTypeChange, updateFormFields, handleEmptyState } from './HostedFieldsServiceHelper';
import { Component } from '../../../constants/CallbackConstants';
import { InputHorizonStyles } from '../../../constants/ThemeConstants';
import { ERRORS } from '../../../constants/Errors';
import { saveUserAddressCommands } from '../../../redux/CommandState/CommandState.actions';
import { CardTypes, ACCOUNT_TYPE } from '../../../constants/PaymentTypes';
import { isEmpty } from '@chegg/utils';
import { getString } from '../../../constants/Strings';
import { doFireStatusUpdate, sendRioEventCallback } from '../../../utils/CallbackUtils';
import { defaultHostedFields } from './DefaultHostedFields';
import { sendNewRelicMessage } from '../../../utils/NewRelicUtils';
import { scrubCardholderName } from '../../../utils/hostedFieldUtil';
import { updateFormFieldData, updatePaymentState, resetPaymentForm, createMOP, updateMOP } from '../../../redux/PaymentState/PaymentState.actions';
import { PAYMENT_PROCESSOR_TYPE } from '@chegg/checkout-sdk';
var CCFIELDS = ValidationManager.types.CCFIELDS;
var HostedFieldsService = /*#__PURE__*/function (_AbstractPaymentMetho) {
  function HostedFieldsService(params) {
    var _this2;
    _classCallCheck(this, HostedFieldsService);
    _this2 = _callSuper(this, HostedFieldsService);
    _defineProperty(_this2, "instance", null);
    _defineProperty(_this2, "braintreeInstance", null);
    _defineProperty(_this2, "dispatch", void 0);
    _defineProperty(_this2, "isEdit", false);
    _defineProperty(_this2, "isInitializing", false);
    // before executing initialize
    _defineProperty(_this2, "isInitialized", false);
    // after initialize is done
    _defineProperty(_this2, "rioNamespace", void 0);
    //In the event that we programmatically clear hosted fields,
    //this flag disables some events to avoid
    //poluting form field state.
    _defineProperty(_this2, "shouldUpdateFormFields", true);
    var instance = params.instance,
      dispatch = params.dispatch,
      rioNamespace = params.rioNamespace;
    _this2.braintreeInstance = instance;
    _this2.dispatch = dispatch;
    _this2.rioNamespace = rioNamespace;
    _this2.initialize();
    return _this2;
  }
  _inherits(HostedFieldsService, _AbstractPaymentMetho);
  return _createClass(HostedFieldsService, [{
    key: "initialize",
    value: function initialize(fieldOptions) {
      var _this3 = this;
      var fields = fieldOptions ? fieldOptions : defaultHostedFields;
      this.isInitializing = true;
      create({
        client: this.braintreeInstance,
        styles: _objectSpread({}, InputHorizonStyles),
        fields: fields
      }, function (err, hostedFieldsInstance) {
        // set aria-required on all the hosted fields
        Object.keys(fields).forEach(function (fieldName) {
          hostedFieldsInstance.setAttribute({
            field: fieldName,
            attribute: 'aria-required',
            value: true
          });
        });
        hostedFieldsInstance.on('cardTypeChange', function (data) {
          handleCardTypeChange(data, _this3.dispatch, _this3.rioNamespace);
        });
        hostedFieldsInstance.on('validityChange', function (event) {
          if (!_this3.shouldUpdateFormFields) return;
          updateFormFields(event, true, hostedFieldsInstance, _this3.dispatch, _this3.rioNamespace);
        });
        hostedFieldsInstance.on('focus', function (event) {
          _this3.shouldUpdateFormFields = true;
          var field = event.emittedBy;

          //Rio logging: When user enters field in the credit card form
          sendRioEvent({
            info: parseString(getString("APP.RIO.EVENTS.EL_NAME.USER_ENTERS_FIELD_".concat(_this3.isEdit ? 'EDIT' : 'ADD')), {
              fieldType: field
            }),
            specType: SpecType.INTERACTION,
            subType: SubType.TEXT,
            elementType: ElementType.TEXT,
            callback: sendRioEventCallback,
            namespace: _this3.rioNamespace
          });
          updateFormFields(event, true, hostedFieldsInstance, _this3.dispatch, _this3.rioNamespace);
        });
        hostedFieldsInstance.on('blur', function (event) {
          if (!_this3.shouldUpdateFormFields) return;
          updateFormFields(event, false, hostedFieldsInstance, _this3.dispatch, _this3.rioNamespace);
        });
        hostedFieldsInstance.on('notEmpty', function (event) {
          _this3.shouldUpdateFormFields = true;
          updateFormFields(event, true, hostedFieldsInstance, _this3.dispatch, _this3.rioNamespace);
        });
        hostedFieldsInstance.on('empty', function (event) {
          if (!_this3.shouldUpdateFormFields) return;
          handleEmptyState(event, _this3.dispatch);
        });
        _this3.instance = hostedFieldsInstance;
        _this3.isInitializing = false;
        _this3.isInitialized = true;
        _this3.dispatch(updatePaymentState({
          isLoading: false
        }));
      });
    }
  }, {
    key: "submit",
    value: function submit(params) {
      var _this4 = this;
      var formFields = params.formFields,
        billingAddress = params.billingAddress,
        isValidAddress = params.isValidAddress,
        deviceData = params.deviceData,
        hasMops = params.hasMops,
        showSubmitButton = params.showSubmitButton;
      var cardholderName = formFields.cardholderName;
      if (!this.instance) return;
      var errors = {};
      var city = billingAddress.city,
        state = billingAddress.state,
        country = billingAddress.country;
      var zip = billingAddress.zip.trim();
      this.instance.tokenize({
        cardholderName: cardholderName.value,
        billingAddress: {
          locality: city,
          region: state,
          postalCode: zip,
          countryCodeAlpha2: country //2char
        }
      },
      // @ts-ignore
      function (err, payload) {
        if (err) {
          var fieldErrors = normalizeErrorMessage(errors, err, _this4.instance, _this4.dispatch);
          var updatedErrors = _objectSpread(_objectSpread({}, errors), fieldErrors);
          if (!isValidAddress) {
            _this4.dispatch(saveUserAddressCommands([{
              commandName: UserAddressCommandNames.VERIFY_ADDRESS
            }]));
          }
          _this4.dispatch(updateFormFieldData(updatedErrors));

          // let host know that there were inline errors
          doFireStatusUpdate([{
            status: StatusTypes.ERROR,
            command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD,
            payload: {
              component: Component.HOSTED_FIELDS_SERVICE,
              errors: [ERRORS.INLINE_ERRORS]
            }
          }]);
          // Keep the Join Now CTA disabled in case of multiple mops
          // and appMode is ADD/EDIT https://chegg.atlassian.net/browse/CW-1014
          if (hasMops || showSubmitButton) {
            doFireStatusUpdate([{
              status: StatusTypes.ERROR,
              command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD_DISABLED,
              payload: {
                component: Component.HOSTED_FIELDS_SERVICE,
                errors: [ERRORS.INLINE_ERRORS]
              }
            }]);
          }
        } else {
          // all hosted fields passed validation.  check and handle any non-hosted fields
          var nonce = payload.nonce,
            details = payload.details;
          if (!isValidAddress || !isEmpty(errors)) {
            _this4.dispatch(saveUserAddressCommands([{
              commandName: UserAddressCommandNames.VERIFY_ADDRESS
            }]));
            _this4.dispatch(updateFormFieldData(errors));
            doFireStatusUpdate([{
              status: StatusTypes.ERROR,
              command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD,
              payload: {
                component: Component.HOSTED_FIELDS_SERVICE,
                errors: [ERRORS.INLINE_ERRORS]
              }
            }]);

            // Keep the Join Now CTA disabled in case of multiple mops
            // and appMode is ADD/EDIT https://chegg.atlassian.net/browse/CW-1014
            if (hasMops || showSubmitButton) {
              doFireStatusUpdate([{
                status: StatusTypes.ERROR,
                command: PaymentMethodsCommandNames.FETCH_PAYMENT_METHOD_DISABLED,
                payload: {
                  component: Component.HOSTED_FIELDS_SERVICE,
                  errors: [ERRORS.INLINE_ERRORS]
                }
              }]);
            }
            return;
          }
          var mopAction = !_this4.isEdit ? createMOP : updateMOP;
          var _cardholderName =
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          details && details['cardholderName'] ? details['cardholderName'] : '';
          var name = scrubCardholderName(_cardholderName);
          _this4.dispatch(mopAction({
            nonce: nonce,
            details: details,
            name: name,
            deviceData: deviceData,
            billing: {
              city: city,
              state: state,
              zip: zip,
              country: country
            },
            accountType: ACCOUNT_TYPE.CREDIT_CARD,
            paymentProcessor: PAYMENT_PROCESSOR_TYPE.BRAINTREE
          }));
        }
      });
    }
  }, {
    key: "clearFields",
    value: function clearFields() {
      this.shouldUpdateFormFields = false;
      _clearFields(this.instance, this.dispatch);
    }
  }, {
    key: "resetForm",
    value: function resetForm() {
      var _this5 = this;
      if (this.instance) {
        this.dispatch(resetPaymentForm());
        this.clearFields();
        this.instance.teardown(function (teardownErr) {
          // test exists for teardownErr, but jest is reporting as uncovered line
          // istanbul ignore next
          if (!teardownErr) {
            _this5.isInitialized = false;
            _this5.initialize(defaultHostedFields);
          }
        });
        this.isEdit = false;
      }
    }

    //params is form fields
  }, {
    key: "hydrate",
    value: function hydrate(params) {
      var _this6 = this;
      var formFields = params.formFields,
        cardType = params.cardType;
      var expirationDate = formFields.expirationDate,
        cardholderName = formFields.cardholderName;
      this.isEdit = true;
      var updatedHostedFields = _objectSpread(_objectSpread({}, defaultHostedFields), {}, _defineProperty(_defineProperty(_defineProperty({}, CCFIELDS.EXPIRATION_DATE, {
        selector: "#".concat(CCFIELDS.EXPIRATION_DATE),
        prefill: expirationDate.value
      }), CCFIELDS.CVV, _objectSpread(_objectSpread({}, defaultHostedFields.cvv), cardType === CardTypes.AMEX ? {
        minlength: 4,
        maxlength: 4
      } : {
        minlength: 3,
        maxlength: 3
      })), CCFIELDS.CARDHOLDER_NAME, _objectSpread(_objectSpread({}, defaultHostedFields.cardholderName), {}, {
        prefill: cardholderName.value
      })));
      //hosted fields not needed for update MOP
      // @ts-ignore
      delete updatedHostedFields.number;
      if (this.instance) {
        this.instance.teardown(function (teardownErr) {
          if (!teardownErr) {
            _this6.initialize(updatedHostedFields);
          } else {
            sendNewRelicMessage('Unable to teardown HostedFields instance', {
              errors: JSON.stringify(teardownErr)
            });
          }
        });
      } else {
        this.initialize(updatedHostedFields);
      }
    }
  }, {
    key: "getIsInitializing",
    value: function getIsInitializing() {
      return this.isInitializing;
    }
    //######################################################################
    //For unit testing purposes only, do not call the methods in actual code
    /* istanbul ignore next */
  }, {
    key: "getHostedFieldsInstance",
    value: function getHostedFieldsInstance() {
      return this.instance;
    }
    /* istanbul ignore next */
  }, {
    key: "setHostedFieldsInstance",
    value: function setHostedFieldsInstance(hostedFieldsInstance) {
      this.instance = hostedFieldsInstance;
    }
    /* istanbul ignore next */
  }, {
    key: "getEdit",
    value: function getEdit() {
      return this.isEdit;
    }
    /* istanbul ignore next */
  }, {
    key: "setEdit",
    value: function setEdit(isEdit) {
      this.isEdit = isEdit;
    }
    /* istanbul ignore next */
  }, {
    key: "getShouldUpdateFormFields",
    value: function getShouldUpdateFormFields() {
      return this.shouldUpdateFormFields;
    }
    /* istanbul ignore next */
  }, {
    key: "setShouldUpdateFormFields",
    value: function setShouldUpdateFormFields(shouldUpdateFormFields) {
      this.shouldUpdateFormFields = shouldUpdateFormFields;
    }
  }]);
}(AbstractPaymentMethodService);
export { HostedFieldsService as default };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/business/processors/braintree/HostedFieldsService.js
// module id = 4586
// module chunks = 11